import { axiosBuzzOne } from '../../../axios';

// Website Builder admin routes. Contract: buzz-one-backend
// src/modules/websiteBuilderAdmin/controller/siteLegacySchool.controller.ts (BCC only).

/**
 * Sets the legacy school a site's contact forms add leads to when the admin's email matches
 * none. → `{ legacySchoolId }`, unwrapped and with no `message`.
 *
 * With `website_builder.legacy_school_fallback` off for the site's school the write is
 * ignored and the call still succeeds, returning `legacySchoolId: ''` — so callers must
 * compare the echo with what they sent rather than trust the 200.
 */
export const setSiteLegacySchool = async (siteId, legacySchoolId) => {
  const response = await axiosBuzzOne({
    method: 'PUT',
    url: `/website-builder/admin/sites/${siteId}/legacy-school`,
    data: { legacySchoolId },
  });
  return response.data;
};
